import React from 'react';
import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Ensures all Bootstrap JS, including ScrollSpy, is loaded,  Needed for accordion toggle
import 'bootstrap-icons/font/bootstrap-icons.css';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';

import { HelmetProvider } from "react-helmet-async"; // for managing meta tags dynamically


import './index.css';








// LLL           EEEEEEEEEEE   GGGGGGGGGGG   AAAAAAAAAAA   CCCCCCCCCCC   YYY       YYY
// LLL           EEEEEEEEEEE   GGGGGGGGGGG   AAAAAAAAAAA   CCCCCCCCCCC   YYY       YYY
// LLL           EEE           GGG           AAA     AAA   CCC            YYY       YYY
// LLL           EEE           GGG           AAA     AAA   CCC             YYY     YYY
// LLL           EEEEEEEEE     GGG   GGGGG   AAAAAAAAAAA   CCC              YYY   YYY
// LLL           EEEEEEEEE     GGG   GGGGG   AAAAAAAAAAA   CCC               YYY YYY
// LLL           EEE           GGG      GGG  AAA     AAA   CCC                YYYYY
// LLL           EEE           GGG      GGG  AAA     AAA   CCC                 YYY
// LLLLLLLLLLL   EEEEEEEEEEE   GGGGGGGGGGG   AAA     AAA   CCCCCCCCCCC         YYY
// LLLLLLLLLLL   EEEEEEEEEEE   GGGGGGGGGGG   AAA     AAA   CCCCCCCCCCC         YYY


//=======================================================================
// INSURANCE
// Check index.html - header, tag manager, ChatBot 
// Check images
// Check sitemap.script -> ROUTES!!!
// ======================================================================
// import AppRoutes_v01 from './Insurance-Legacy/App_v01_LegacyInsurance_Routes';

// CONTRACTORS INSURANCE
// import AppRoutes_v01 from './easy-contractor/App_v01_EasyContractor_Insurance_Routes';

//PAINTERS INSURANCE 
// import AppRoutes_v01 from './discount-painters-insurance/App_v01_DISCOUNT_PAINTERS_Routes';
// 
































// LLL          IIIIIIIIIII  VVV       VVV  EEEEEEEEEEE     AAAAA          GGGGGGGGGGG  EEEEEEEEEEE  NNN        NNN  TTTTTTTTTTT
// LLL              III      VVV       VVV  EEEEEEEEEEE    AAAAAAA         GGGGGGGGGGG  EEEEEEEEEEE  NNNN       NNN  TTTTTTTTTTT
// LLL              III      VVV       VVV  EEE            AAA   AAA       GGG          EEE          NNNNN      NNN      TTT
// LLL              III      VVV       VVV  EEE           AAA     AAA      GGG          EEE          NNN NNN    NNN      TTT
// LLL              III       VVV     VVV   EEEEEEEEE     AAAAAAAAAAA      GGG   GGGGG  EEEEEEEEE    NNN  NNN   NNN      TTT
// LLL              III        VVV   VVV    EEEEEEEEE     AAAAAAAAAAA      GGG   GGGGG  EEEEEEEEE    NNN   NNN  NNN      TTT
// LLL              III         VVV VVV     EEE           AAA       AAA    GGG      GGG EEE          NNN    NNN NNN      TTT
// LLL              III          VVVVV      EEE           AAA       AAA    GGG      GGG EEE          NNN     NNNNNN      TTT
// LLLLLLLLLLL  IIIIIIIIIII       VVV       EEEEEEEEEEE   AAA       AAA    GGGGGGGGGGG  EEEEEEEEEEE  NNN      NNNNN      TTT
// LLLLLLLLLLL  IIIIIIIIIII       VVV       EEEEEEEEEEE   AAA       AAA    GGGGGGGGGGG  EEEEEEEEEEE  NNN       NNNN      TTT


//  33333333333    66666666666    55555555555
// 333333333333   666666666666   55555555555
//           333  666            555
//           333  666            555
//    3333333333   66666666666   55555555555
//    3333333333   66666666666           555
//           333   666       666          555
//           333   666       666          555
// 333333333333    666666666666   55555555555
//  33333333333     66666666666   55555555555 
 






// LIVE AGENT 365  / VOICE AGENT 
// ACTIVE VERISON 
// import AppRoutes_v01 from './VoiceAgent365/LiveAgent365UpdatePrompts/LiveAgentACTIVE/LiveAgent365Page_v02_v3g_A2P_v3i_UPDATED';



// import AppRoutes_v01 from './VoiceAgent365/LiveAgent365UpdatedComponents/LiveAgent365Routing'

//import AppRoutes_v01 from './VoiceAgent365/SecialAgents/DentalBot365_Landing_v01'



// import AppRoutes_v01 from './VoiceAgent365/ACTIVE-VoiceAgent365LandingPage_2025_12_15_chat_v5-api';
//import AppRoutes_v01 from './VoiceAgent365/VoiceAgent365LandingPage_2025_12_15_chat_v5-api';


// import AppRoutes_v01 from './VoiceAgent365/LiveAgent365UpdatePrompts/LiveAgentACTIVE/LiveAgent365_v02_updated_fixed7_router_header_footer_contact';




// SHOT CLOCK
// https://chatgpt.com/c/69a04ea0-a264-832e-b441-2a167e0d1197
// import AppRoutes_v01 from './SHOT-CLOCK/ShotClockLanding_v01nc';








//OTHER VERSIONS 
// ==================================================================================================
// import AppRoutes_v01 from './VoiceAgent365/ACTIVE-VoiceAgent365LandingPage_2025_12_15_chat_v5-api';
// import AppRoutes_v01 from './VoiceAgent365/VoiceAgent365LandingPage_2025_12_15_chat_v5b-api'; //SIMPLIFIED VERSION 
// import AppRoutes_v01 from './VoiceAgent365/App_v01_LiveAgent365_Routes';
 
// import AppRoutes_v01 from './VoiceAgent365/LiveAgent365_Worksheet_v01_2026_01_05_chat';

// LIVE AGENT 365  / MISSED CALL CALCULATOR 
// import AppRoutes_v01 from './VoiceAgent365/MissedCallCalculator_v02-Cleaner';
//  import AppRoutes_v01 from './VoiceAgent365/MissedCallCalculator_v03-landingpage_chat_2025_12_18_v01'

// cash clone
// import AppRoutes_v01 from './VoiceAgent365/MissedCallCalculator_v04-Landing-MCCash_copy_chat_2025_12_18_v01'










//IT SECURITY SCORE CARD.COM
// ===================================================================================================
//import AppRoutes_v01 from './ITSecurityScoreCard/ITSecurityScoreCard_focused_2025_12_18_v02_Chat';
//import AppRoutes_v01 from './ITSecurityScoreCard/HIPPA-ScoreCard-v01-chat'
//import AppRoutes_v01 from './ITSecurityScoreCard/PCICompliance_v01_2026_01_19_chat';
// import AppRoutes_v01 from './ITSecurityScoreCard/SOC2Compliance_v01_2026_01_19_chat';


// EASY TRASH OUT
// EASY JUNK OUT
//  import AppRoutes_v01 from './easy-trash-out/App_v01_Trashout_Routes';






// Good Version
// C:\aaa\SoftDev2024\ReactDev2024-GOOD-DEMOS\00-insurance-master-website-v01\src\ONE-PAGE-HTML-WEBSITES\TEMPLATE-V01B-carousel-JunkRemoval.html
// import AppRoutes_v01 from './easy-trash-out/EasyTrashOut_Landing_2025_12_15_chat';




//latest - Jan 28 2026
//  import AppRoutes_v01 from './EASY-JUNK-OUT-2026/EasyJunkOutLanding_v01'





// file:///C:/aaa/SoftDev2024/ReactDev2024-GOOD-DEMOS/00-insurance-master-website-v01/src/ONE-PAGE-HTML-WEBSITES/TEMPLATE-V01B-carousel-JunkRemoval.html
//import AppRoutes_v01 from  './easy-trash-out/EasyJunkOut_2025_12_18_Gemini' // too simple
// import AppRoutes_v01 from  './easy-trash-out/EasyJunkOut_v01_2026_01_21_Chat'// too busy






//AIR QUALITY SCORE CARD ------------------------------------
//  import AppRoutes_v01 from './AirQualityScoreCard/AirQualityScoreCard_Landing_v02-Chat'
// file:///C:/aaa/SoftDev2024/ReactDev2024-GOOD-DEMOS/00-insurance-master-website-v01/src/ONE-PAGE-HTML-WEBSITES/CLEAN-AIR-SCORECARD_V01_Chat.html




//PROACTIVE PLUMBER 
// import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing'
// import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_17_gemini'
// import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_19_gemini';
// import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_19_chat';

//import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_19_chat_v02';

//  import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_19_chat_v07';
 //import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_19_chat_v08';
// import AppRoutes_v01 from './ProactivePlumber/ProactivePlumber_Landing_2025_12_23_chat_v09';


//MORTGAGE READY 
// import AppRoutes_v01 from './mortgage-ready/mortgageReadyLanding_v01-Chat'





//DenverWallGraphics
// =============================================
//import AppRoutes_v01 from './DenverWallGraphics/DenverWallGraphics_v01-Chat';



// import AppRoutes_v01 from './BoatRental/fishing_booking_widget_v_01a';



// all STAR POST CARDS
// import AppRoutes_v01 from './Postcards2026/AllStarPostcards/AllStarPostcards_landing_v01';


//SHOWCASE DATA TEST
// import AppRoutes_v01 from './00UI-Utilities/Showcase/Showcase_component_v01'



// WAIT LIST COMPONENT 
// -------------------------------------------------
// import AppRoutes_v01  from './WAIT-LIST-COMPONENT/WaitListComponent_App';




//EASY STUMP OUT 
// ===============================================
//import AppRoutes_v01 from './EasyStumpOut/Split_v03_full/App_ROUTES_EasyStump_v01';  //ACTIVE MAY 2026
 import AppRoutes_v01 from './EasyStumpOut/Split_v03_full/App_ROUTES_CheyenneStumpRemoval_v01';
// ---------------------------------------------------------------------------
// Note: same code base for Cheyenne and easystump - same images as well
// ---------------------------------------------------------------------------


// not sure about this one 4/29/2026
// /import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03g_dropin_replacement';




// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03i-config-update'; //latest 
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03h-manual-update'; //latest 
//import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03g'; //2026 03 30 Monday - Added a Recient Projects section
 //import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03f'; //2026 02 20
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03c'; //2026 02 20
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03b'; //2026 02 20
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v03a'; //2026 02 20
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat_A2P_API_UPDATED_v02';
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_2026_02_07_chat';

//THE GOOD VERSION IS AN HTML FILE. 
// SEE:
// C:\aaa\SoftDev2024\ReactDev2024-GOOD-DEMOS\00-insurance-master-website-v01\src\ONE-PAGE-HTML-WEBSITES\DEPLOYMENT-VERSIONS\EASY STUMP OUT\EASY-STUMP-OUT-2026-01-07-1045AM

// CHAT VERSION - NO SO GOOD
// import AppRoutes_v01 from './EasyStumpOut/EasyStumpOut_Landing_2025_12_21';



//CHEYENNE STUMP REMOVAL 
// import AppRoutes_v01 from './EasyStump-Cheyenne-WY/CheyenneStumpRemoval_2026_02_20_chat_A2P_API_UPDATED_v01b'; //2026 02 20






//DASHBOARD - STOCK MARKET 
// import AppRoutes_v01 from './component-demos/DASHBOARD-DEMOS/ChartDashboard_v01';

//BIG POST CARD
//HOME RUN POST CARDS
//import AppRoutes_v01 from './POST-CARDS/HomeRunPostCards_Landing_2025_12_28_chat';



//CUSTOMER CAROUSEL 
// import AppRoutes_v01 from './CUSTOMER-CAROUSEL/CustomerCarousel_Landing_2025_12_22_chat';
// import AppRoutes_v01 from './CUSTOMER-CAROUSEL/CustomerCarousel_Landing_2025_12_22_chat_v02';

// import AppRoutes_v01 from './CUSTOMER-CAROUSEL/BirthdayClubLanding_2025_12_22_v01';



// https://docs.aws.amazon.com/aws-certification/latest/examguides/aws-certification-exam-guides.html



// DUI Insurance
// OLD REV  import AppRoutes_v01 from './DUIInsurance/App_v01_DUIInsurance_Routes';
// import AppRoutes_v01 from './EasyDUI-Insurance/App_v01_EasyDUI_Insurance_Routes';


// RENTERS - DISCOUNT RENTERS INSURANCE.COM
// import AppRoutes_v01 from './discount-renters-insurance/App_v01_DiscountRentersInsurance_Routes';

// EASY DUI
// import AppRoutes_v01 from './EasyDUI-Insurance/App_v01_EasyDUI_Insurance_Routes';

// LONGEVITY
// import AppRoutes_v01 from './LONGEVITY-HealthAdvisors/App_v01_LONGEVITY_Routes';




// EASY Welding
// import AppRoutes_v01 from './Discount-Welding-2025/App_v01_Welding_Insurance_Routes';

// CUSTOM EDGE 
// import AppRoutes_v01 from './Custom-Edge-Fabrication/App_v01_CustomEdge_Routing';








// VENDING 

// import AppRoutes_v01 from './sundance-vending/App_v01_SundanceVending_Routes';






//DOG WALKING
// import AppRoutes_v01 from './DOG-WALKING/DogWalkingHomePage_v03-chat';


// WAIT LIST APP 
// import AppRoutes_v01 from './WAIT-LIST-APP/WaitListApp_v01';


//SPORTS CAR DEMO
// import AppRoutes_v01 from './component-demos/00-REACT-DEMOS/SportsCarDemo/SportsCarDemo_v01';
// import AppRoutes_v01 from './LONGEVITY-HealthAdvisors/LONGEVITY-SCORECARD/LongevityScoreCard_v01_Landing_Chat_2026_18_02'


//HANDY MAN
// import AppRoutes_v01 from './PROACTIVE-HANDY-MAN/TheProactiveHandyMan_v01';


// MEMORY SCORE CARD
// import AppRoutes_v01 from './ScoreCards/memoryScoreCard/App_v01_MemoryScoreCard_Routes';

// SMART MONEY.CREDIT
// import AppRoutes_v01 from './ScoreCards/SmartMoneyCredit/App_v01_SmartMoney_Routes';
// CreditCardScoreBoard

//  AppRoutes_v01 from './ScoreCards/CreditCardScoreBoard/CreditCardScoreBoard_v01-2026-01-18-gemini'
  // CreditCardScoreBoard_v01_2026_01_18_gemini



// TAX DEEP DIVE 
//  import AppRoutes_v01 from './TaxDeepDive/TaxReturnScoreCard';




// DIVORCE READY 
// import AppRoutes_v01 from './ScoreCards/DivorceReady/App_v01_DivorceReadyScoreCard_Routes';


// HOSTING SCORE CARD

// CLOUD TRAINING - CLOUD LEADERSHIP TEAM  - SEE ROUTING FOR PAGE UPDATES
//  import AppRoutes_v01 from './CertifiedCloudTraining/App_00_ROUTES_CertifiedCloudTraining_v01';





//  import  AppRoutes_v01  from "./certified-cloud-training/App_v01_CertifiedCloudTraining";

//CERTIFIED CLOUD COACH 
// import AppRoutes_v01 from './CertifiedCloudCoach/CertifiedCloudCoach_LandingPage_v01';


//SWAT
// import AppRoutes_v01 from './SWAT/SWAT_LANDING_PAGE_V01';


// import AppRoutes_v01 from './hot-limo/App_v01_HotLimo';

//TIMBERLINE CLOUD
// import AppRoutes_v01 from './TimberlineCloud/App_00_ROUTES_TimberlineCloud_v01';// LATEST 4/20/2026
// import AppRoutes_v01 from './TimberlineCloud/AIVoiceReceptionistDemoPage_v01d_reactnode_data-SIMPLE';

   // import AppRoutes_v01 from "./TimberlineCloud/TimberLineCloudLandingPage_v01"; //NEW VERSION 2026

// import AppRoutes_v01 from "./timberline-cloud/App_v01_TimberLineCloud_Routes";




//QUIZ APP and flash card app. Need to make matching app

//LATEST CERTIFIED CLOUD TRAINING LANDING 
// import AppRoutes_v01 from "./CertifiedCloudTraining/App_00_ROUTES_CertifiedCloudTraining_v01";

// import AppRoutes_v01 from "./CertifiedCloudTraining/TriviaQuizGame_v03";


//CERTIFIED DRONE TEAM 
// import AppRoutes_v01 from "./CertifiedDroneTeam/CertifiedDroneTeam_Lainding_v02";


//CERTIFIED DRONE TEAM 
// import AppRoutes_v01 from "./303Pavement/303Pavement_Landing_v01";



//CERTIFIED DRONE TEAM 
// import AppRoutes_v01 from "./303Pavement/303Pavement_reactset2026_v01/303Pavement_reactset2026_v01/src/App";




// import AppRoutes_v01 from "./QuizApp/ReactSet2026_QuizModule_v01m";
// import AppRoutes_v01 from "./QuizApp/ReactSet2026_FlashCardsModule_v02-ReactNode";

 
 //import AppRoutes_v01 from "./QuizApp/QuizApp_Matching_v01e";


//BOAT RENTAL
// import AppRoutes_v01 from "./BoatRental/BoatRentalCharterUI_v01";




//303 EventRental 
//import AppRoutes_v01 from "./303EventRental/EventRental_LandingPage_v04";


// CertifiedBankCard.com
// =======================================================================================================
// import AppRoutes_v01 from "./CertifiedBankCard/CertifiedBankCard_split_pages_v01/CertifiedBankcard_ROUTES_v01"; //LATEST 

//  import AppRoutes_v01 from "./CertifiedBankCard/CertifiedBankCard_landingPage_v04";





//FiestaSigns.com
//import AppRoutes_v01 from "./FiestaSigns/FiestaSigns_ReactSetv022026BSSC_v01/fiestasigns/FiestaSigns_HomePage_v01"
// import AppRoutes_v01 from "./FiestaSigns/FiestaSigns_ReactSetv022026BSSC_v01/FiestaSigns_ProductShowcase_v01b" 
// import AppRoutes_v01 from "./FiestaSigns/FiestaSigns_ReactSet_Files_v01/FiestaSigns_HomePage_v01";

// import AppRoutes_v01 from "./FiestaSigns/FiestaSigns_Landing_RWB_v00a";
// import AppRoutes_v01 fro "./FiestaSigns/FiestaSignsLandingPage_v01";





//EASY COUCH REMOVAL.COM
// import AppRoutes_v01 from "./EasyCouchRemoval/EasyCouchRemoval_LandingPage_v02";
//=======================================================================


//POS QUIZ 
//import AppRoutes_v01 from "./POS-Quiz/POSQuiz_landingPage_v01";
// import AppRoutes_v01 from "./POS-Quiz/POSQuiz_Questions_v01";
//=======================================================================





///"Best in class" service means a service that consistently surpasses customer expectations, delivers rapid and effective solutions, and creates a positive customer experience. It's about being the top performer within a category, outshining competitors in key areas like quality, customer satisfaction, and efficiency. Essentially, it's service that is not just good, but exceptional and consistently so. 
// https://www.superoffice.com/blog/best-in-class-customer-service/



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
        <AppRoutes_v01 />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();



